var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/activityfeed/parts/createcpmsession',["require", "exports", "common/parts", "areas/activityfeed/models/dto"], function (require, exports, Parts, Dto) {
    "use strict";
    var CreateCPMSession = (function (_super) {
        __extends(CreateCPMSession, _super);
        function CreateCPMSession(baseUrl) {
            _super.call(this);
            this._baseUrl = baseUrl;
        }
        CreateCPMSession.prototype.process = function (symbol) {
            var _this = this;
            try {
                var url = this._baseUrl + "/sdn/rest/directory/CreateSession?locale=en&session=&organization=";
                Q(jQuery.ajax(url, {
                    type: "GET",
                    async: true,
                    beforeSend: function (xhr, settings) {
                        xhr.setRequestHeader("Authorization", "Bearer " + symbol.token.access_token);
                    },
                    contentType: "application/json"
                }))
                    .then(function (response) {
                    var result = new Dto.SessionResponse();
                    result.token = symbol.token;
                    result.sessionId = response.id;
                    result.organizationId = response.organization;
                    _this.output.call(result);
                });
            }
            catch (error) {
                this.error.call(error);
            }
        };
        return CreateCPMSession;
    }(Parts.Part));
    return CreateCPMSession;
});

